export enum PERMISSIONS {
  FLIGHT_CREW_SCHEDULING_SYSTEM = "PANEL:FLIGHT_CREW_SCHEDULING_SYSTEM",
  COCKPIT_CREW_LIST = "PANEL:COCKPIT_CREW_LIST",
  CABIN_CREW_LIST = "PANEL:CABIN_CREW_LIST",
  CHANGE_CABIN_CREW_ACTIVATION = "PANEL:CHANGE_CABIN_CREW_ACTIVATION",
  CHANGE_COCKPIT_CREW_ACTIVATION = "PANEL:CHANGE_COCKPIT_CREW_ACTIVATION",
  UPDATE_CREW_SIGNIFICANT_NOTE = "PANEL:UPDATE_CREW_SIGNIFICANT_NOTE",
  ADD_COCKPIT_CREW_JOB = "PANEL:ADD_COCKPIT_CREW_JOB",
  ADD_CABIN_CREW_JOB = "PANEL:ADD_CABIN_CREW_JOB",
  EDIT_COCKPIT_CREW_JOB = "PANEL:EDIT_COCKPIT_CREW_JOB",
  EDIT_CABIN_CREW_JOB = "PANEL:EDIT_CABIN_CREW_JOB",
  CREATE_COCKPIT_CREW = "PANEL:CREATE_COCKPIT_CREW",
  EDIT_COCKPIT_CREW = "PANEL:EDIT_COCKPIT_CREW",
  CREATE_CABIN_CREW = "PANEL:CREATE_CABIN_CREW",
  EDIT_CABIN_CREW = "PANEL:EDIT_CABIN_CREW",
  DOCUMENT_TEMPLATE_ASSIGN_JOB = "PANEL:DOCUMENT_TEMPLATE_ASSIGN_JOB",
  CREATE_DOCUMENT_TEMPLATE = "PANEL:CREATE_DOCUMENT_TEMPLATE",
  CHANGE_DOCUMENT_TEMPLATE_ACTIVATION = "PANEL:CHANGE_DOCUMENT_TEMPLATE_ACTIVATION",
  EDIT_DOCUMENT_TEMPLATE = "PANEL:EDIT_DOCUMENT_TEMPLATE",
  DOCUMENT_TEMPLATE_LIST = "PANEL:DOCUMENT_TEMPLATE_LIST",
  FLIGHT_MANAGEMENT_SYSTERM = "PANEL:FLIGHT_MANAGEMENT_SYSTERM",
  ELECTRONIC_DOCUMENT_MANAGEMENT_SYSTEM = "PANEL:ELECTRONIC_DOCUMENT_MANAGEMENT_SYSTEM",
  TURNAROUND_MANAGEMENT_SYSTEM = "PANEL:TURNAROUND_MANAGEMENT_SYSTEM",
  INVOICE_MANAGEMENT_SYSTEM = "PANEL:INVOICE_MANAGEMENT_SYSTEM",
  CONTINUOES_AIRWORTHINESS_MONITORING_SYSTEM = "PANEL:CONTINUOES_AIRWORTHINESS_MONITORING_SYSTEM",
  MASTER_DATA_MANAGEMENT = "PANEL:MASTER_DATA_MANAGEMENT",
  READ_COCKPIT_CREWS_DOCUMENTS = "PANEL:READ_COCKPIT_CREWS_DOCUMENTS",
  WRITE_COCKPIT_CREWS_DOCUMENTS = "PANEL:WRITE_COCKPIT_CREWS_DOCUMENTS",
  READ_CABIN_CREWS_DOCUMENTS = "PANEL:READ_CABIN_CREWS_DOCUMENTS",
  WRITE_CABIN_CREWS_DOCUMENTS = "PANEL:WRITE_CABIN_CREWS_DOCUMENTS",
  READ_CABIN_CREWS_CONTACT_INFO = "PANEL:READ_CABIN_CREWS_CONTACT_INFO",
  WRITE_CABIN_CREWS_CONTACT_INFO = "PANEL:WRITE_CABIN_CREWS_CONTACT_INFO",
  READ_COCKPIT_CREWS_CONTACT_INFO = "PANEL:READ_COCKPIT_CREWS_CONTACT_INFO",
  WRITE_COCKPIT_CREWS_CONTACT_INFO = "PANEL:WRITE_COCKPIT_CREWS_CONTACT_INFO",
}
